import { jsx as _jsx } from "react/jsx-runtime";
import { useEffect, useRef, useState } from 'react';
import { isMobile, sectionChangeTimeout, sectionChangeTimeoutShort, snapTargetClass, } from '../globalUtils';
import usePageStore from './pageStore';
import useDataStore from '../Data/dataStore';
const observerOptions = {
    root: null,
    rootMargin: '-5px 0px -65px 0px',
};
const centerObserverOptions = {
    root: null,
    rootMargin: '-50% 0px -50% 0px',
};
const PageSection = ({ id, idx, forceSnap, flexibleHeight, children, }) => {
    const { activePage, shownPage, activeSection, shownSection, blockSnap } = usePageStore();
    const [, setRender] = useState(0);
    const [allowedToSnap, setAllowedToSnap] = useState(false);
    /* const isActiveSection = useRef(false); */
    const sectionRef = useRef(null);
    const snapElement = useRef(document.createElement('div'));
    const showTimeout = useRef(0);
    const shownSectionRef = useRef(shownSection);
    shownSectionRef.current = shownSection;
    useEffect(() => {
        document.addEventListener('content', handleResize);
        if (sectionRef.current) {
            addListeners();
        }
        snapElement.current.classList.add(snapTargetClass);
        snapElement.current.classList.add(`${snapTargetClass}${idx}`);
        snapElement.current.id = id;
        if (isMobile) {
            // we don't apply force snapping on mobiles since it breaks the mobile browsers on iOS
            snapElement.current.style.scrollSnapAlign = 'start';
        }
        setTimeout(() => setAllowedToSnap(true), 200);
        return () => {
            if (snapElement.current.parentNode) {
                snapElement.current.parentNode.removeChild(snapElement.current);
            }
            document.removeEventListener('content', handleResize);
            removeListeners();
        };
    }, []);
    useEffect(() => {
        if (activeSection !== idx) {
            clearTimeout(showTimeout.current);
        }
    }, [activeSection]);
    useEffect(() => setupSnapping(shownSection), [shownSection, allowedToSnap]);
    useEffect(() => setupSnapping(activeSection), [blockSnap]);
    const setupSnapping = (section) => {
        if (allowedToSnap && snapElement.current) {
            const showSnap = forceSnap
                ? section === idx || section === idx - 1 || section === idx + 1
                : true;
            // block snapping if activeSection and shown section is not the same;
            const blockInBetweenPage = activePage !== shownPage || activeSection !== shownSection;
            if (!snapElement.current.parentNode) {
                document.body.appendChild(snapElement.current);
            }
            if (!isMobile) {
                if (showSnap && !blockInBetweenPage) {
                    snapElement.current.style.scrollSnapAlign = 'start';
                }
                else {
                    snapElement.current.style.scrollSnapAlign = 'unset';
                }
            }
        }
    };
    const handleCenterIntersect = (elements) => {
        checkIntersect(elements, true);
    };
    const handleIntersect = (elements) => {
        checkIntersect(elements);
    };
    const handleResizeObserver = (entries) => {
        if (entries.length > 0) {
            handleResize();
        }
    };
    const handleResize = () => {
        requestAnimationFrame(onResize);
    };
    const onResize = () => {
        if (!sectionRef.current)
            return;
        const bounds = sectionRef.current.getBoundingClientRect();
        snapElement.current.style.top = `${bounds.y + document.documentElement.scrollTop}px`;
    };
    const checkIntersect = (elements, isCenter) => {
        const intersection = elements.reduce((acc, element) => element.target === sectionRef.current && element.isIntersecting
            ? element
            : acc, null);
        if (isCenter) {
            if (intersection) {
                const prevSection = usePageStore.getState().activeSection;
                const sections = useDataStore.getState().data[shownPage]?.page_sections;
                if (prevSection !== idx) {
                    usePageStore.getState().setActiveSection(idx);
                    const anim = sections?.[idx]?.animation;
                    const sectionHasAnimation = !!anim && anim !== 'none';
                    clearTimeout(showTimeout.current);
                    showTimeout.current = window.setTimeout(() => {
                        usePageStore.getState().setShownSection(idx);
                    }, shownSectionRef.current < 0
                        ? 0
                        : (sectionHasAnimation
                            ? sectionChangeTimeout
                            : sectionChangeTimeoutShort) * 1000);
                }
            }
        }
        else {
            /* if (intersection) {
              if (!isActiveSection.current) {
                isActiveSection.current = true;
                setRender((x) => x + 1);
              }
            } else {
              if (isActiveSection.current) {
                isActiveSection.current = false;
                setRender((x) => x + 1);
              }
            } */
        }
    };
    const observer = useRef(new IntersectionObserver(handleIntersect, observerOptions));
    const centerObserver = useRef(new IntersectionObserver(handleCenterIntersect, centerObserverOptions));
    const resizeObserver = useRef(new ResizeObserver(handleResizeObserver));
    const addListeners = () => {
        if (sectionRef.current) {
            observer.current.observe(sectionRef.current);
            centerObserver.current.observe(sectionRef.current);
            resizeObserver.current.observe(sectionRef.current);
        }
    };
    const removeListeners = () => {
        observer.current.disconnect();
        centerObserver.current.disconnect();
        resizeObserver.current.disconnect();
    };
    return (_jsx("section", { id: id, className: `page-section${flexibleHeight ? ' flexible' : ''}`, ref: sectionRef, children: children }, id));
};
export default PageSection;
